import { actionCopyDe } from "./actionCopy";
import { listCopyDe } from "./listCopy";

export const patientsCopyDe = {
    patients: "Patienten",
    navPatientsDescription: "Verwalten Sie Ihre Patienten an einem Ort.",
    patientFallback: "Patient",
    action: "Aktion",
    trackerEntry: "Tracker-Eintrag",
    patientsError: "Patienten-Fehler",
    error: "Fehler",
    tabActive: "Aktiv",
    tabPending: "Ausstehend",
    tabInactive: "Inaktiv",
    search: actionCopyDe.search,
    searchPatientsAria: "Patienten suchen",
    searchForPatient: "Patient suchen",
    searchDescription: "Suche nach Name, E-Mail, Geburtsdatum, Krankenhausnummer oder Tagebuchname",
    searchPlaceholder: "Nach Name, E-Mail, Geburtsdatum, Krankenhausnummer suchen…",
    noResultsFound: "Keine Ergebnisse gefunden",
    trySearchingHint: "Versuchen Sie die Suche nach Name, E-Mail, Geburtsdatum oder Krankenhausnummer",
    enterSearchTerm: "Suchbegriff eingeben, um Patienten zu finden",
    loadingDiaries: "Tagebücher werden geladen…",
    errorLoadingDiaries: (message) => `Fehler beim Laden der Tagebücher: ${message}`,
    unknownPatient: "Unbekannter Patient",
    dateOfBirthLabel: "Geburtsdatum",
    noDiariesOnPage: "Keine Tagebücher auf dieser Seite",
    showingDiaries: (start, end, total) => `Tagebücher ${start} bis ${end} von ${total}`,
    patientsPerPage: "Patienten pro Seite",
    emptyFirstPatientTitle: "Laden Sie Ihren ersten Patienten ein",
    emptyFirstPatientDescription:
        "Wählen Sie eine Tagebuch-Einrichtung, prüfen Sie die Details und senden Sie eine Einladung. Der Fortschritt erscheint hier.",
    emptyFirstPatientCta: "Erstes Tagebuch hinzufügen",
    emptyFirstPatientHelpLink: "Wie lade ich einen Patienten ein?",
    emptyTabTitle: (tabLabel) => `Keine ${tabLabel.toLowerCase()} Tagebücher`,
    emptyTabDescription:
        "Tagebücher in anderen Tabs sind weiterhin verfügbar. Wechseln Sie den Tab oder laden Sie einen weiteren Patienten ein.",
    notDefined: "Nicht angegeben",
    columnDiaryStatus: "Tagebuchstatus",
    columnStartDate: "Startdatum",
    columnPatientName: "Patientenname",
    columnOrganisation: listCopyDe.organisation,
    columnLabels: listCopyDe.labels,
    columnDateOfBirth: listCopyDe.dateOfBirth,
    columnHospitalNumber: "Krankenhausnummer",
    columnRead: "Geprüft",
    filters: actionCopyDe.filters,
    filterDiariesAria: "Tagebücher filtern",
    viewSettings: "Ansichtseinstellungen",
    viewSettingsDescription:
        "Tagebuch-Umfang, Status, geteilte Behandler, Labels und Organisationsfilter für diese Liste wählen.",
    sharedWithClinicians: "Geteilt mit Behandlern",
    diaryStatus: "Tagebuchstatus",
    selectStatuses: "Status auswählen",
    labels: listCopyDe.labels,
    organisation: listCopyDe.organisation,
    save: actionCopyDe.save,
    apply: actionCopyDe.apply,
    sortDiariesTitle: "Tagebücher sortieren",
    sortDiariesDescription:
        "Feld und Reihenfolge für diese Liste wählen. Die Sortierung gilt für alle Tagebücher im aktuellen Tab, nicht nur diese Seite.",
    diaryScope: "Tagebuch-Umfang",
    directAccess: "Direkter Zugriff",
    allDiariesInOrganisation: "Alle Tagebücher in meiner Organisation",
    selectClinicians: "Behandler auswählen",
    selectLabels: "Labels auswählen",
    clearFilters: "Filter zurücksetzen",
    selectOrganisations: "Organisationen auswählen",
    sortDiariesAria: "Tagebücher sortieren",
    sortBy: "Sortieren nach",
    order: "Reihenfolge",
    sortAscending: "Aufsteigend",
    sortDescending: "Absteigend",
    sortState: "Status",
    sortStartDate: "Startdatum",
    sortFirstName: "Vorname",
    sortLastName: "Nachname",
    sortDateOfBirth: "Geburtsdatum",
    sortHospitalNumber: "Krankenhausnummer",
    read: "Geprüft",
    unread: "Nicht geprüft",
    noDiarySelected: "Kein Tagebuch ausgewählt",
    refreshDiary: "Tagebuch aktualisieren",
    noDiaryFound: "Kein Tagebuch gefunden.",
    diaryCouldNotLoad: "Tagebuch konnte nicht geladen werden.",
    profileCouldNotLoad: "Profil konnte nicht geladen werden.",
    diaryDetails: "Tagebuchdetails",
    patientDetails: "Patientendetails",
    unknownState: "Unbekannter Status",
    edit: actionCopyDe.edit,
    done: actionCopyDe.done,
    none: actionCopyDe.none,
    contact: "Kontakt",
    noContactPerson: "Keine Kontaktperson",
    lastEntry: (relative) => `Letzter Eintrag ${relative}`,
    diaryOrganisation: "Tagebuch-Organisation",
    organisationAndContact: "Organisation und Kontakt",
    editCareDetails: "Versorgungsdetails bearbeiten",
    labelsStudyTrial: "Labels (Studie / Trial)",
    contactName: "Kontaktname",
    contactLabel: (name) => `Kontakt: ${name}`,
    nameLabel: "Name",
    emailLabel: "E-Mail",
    openLink: "Link öffnen",
    dateRangeToNow: (start) => `${start} bis heute`,
    dateRangeTo: (start, end) => `${start} bis ${end}`,
    informationToComplete: "Auszufüllende Informationen",
    clinicianTasks: (entryCount, formCount) =>
        `Sie haben ${entryCount === 1 ? "1 fälligen Eintrag" : `${entryCount} fällige Einträge`} in ${
            formCount === 1
                ? "1 Formular, das das Team ausfüllen muss."
                : `${formCount} Formularen, die das Team ausfüllen muss.`
        }`,
    completeNextForm: "Nächstes Formular ausfüllen",
    completeForm: (title) => `${title} ausfüllen`,
    questionnaire: "Fragebogen",
    more: actionCopyDe.more,
    moreActions: "Weitere Aktionen",
    moreActionsAria: "Weitere Aktionen",
    printDiary: "Tagebuch drucken",
    shareDiary: "Tagebuch teilen",
    openFullScreen: "Vollbild öffnen",
    messageHistory: "Nachrichtenverlauf",
    deleteDiary: "Tagebuch löschen",
    deleteDiaryTitle: "Tagebuch löschen",
    deleteDiaryDescription: "Sind Sie sicher, dass Sie dieses Tagebuch löschen möchten?",
    cancel: actionCopyDe.cancel,
    delete: actionCopyDe.delete,
    updateDiary: "Tagebuch aktualisieren",
    addToDiary: "Zum Tagebuch hinzufügen",
    addEvent: "Ereignis hinzufügen",
    addConsent: "Einwilligung hinzufügen",
    addQuestionnaire: "Fragebogen hinzufügen",
    addFromTemplate: "Aus Vorlage hinzufügen",
    addEventDescription:
        "Fügen Sie eine Behandlung hinzu und verknüpfen Sie sie mit einem bestehenden Datum, oder legen Sie ein neues an.",
    addConsentDescription:
        "Hängen Sie eine Einwilligung an eine Behandlung, oder fügen Sie eine mit eigenem Datum hinzu.",
    addQuestionnaireDescription:
        "Fügen Sie einen Fragebogen hinzu und verknüpfen Sie ihn mit einem bestehenden Datum, oder legen Sie ein neues an.",
    addFromTemplateDescription: "Wenden Sie eine gespeicherte Vorlage auf dieses Tagebuch an.",
    addConsentTitle: "Einwilligung hinzufügen",
    addConsentDescriptionLong: "Wählen Sie eine Behandlung, oder fügen Sie eine Einwilligung mit eigenem Datum hinzu.",
    selectProcedureDate: "Behandlung",
    notForAnEvent: "Nicht für ein Ereignis",
    consentDate: "Datum",
    noProcedureDatesForConsent: "Fügen Sie zuerst eine Behandlung hinzu.",
    addEventFirst: "Zuerst Ereignis hinzufügen",
    selectConsent: "Einwilligung",
    selectConsentHelp: "Wählen Sie eine veröffentlichte Einwilligung für dieses Tagebuch.",
    noPublishedConsents:
        "Keine veröffentlichten Einwilligungen vorhanden. Ein Admin kann eine im Einwilligungs-Builder veröffentlichen.",
    consentRoles: "Wer unterschreiben muss",
    consentRolesHelp: "Die ausgewählten Personen werden aufgefordert, diese Einwilligung zu unterschreiben.",
    saveConsent: "Einwilligung hinzufügen",
    savingConsent: "Einwilligung wird hinzugefügt…",
    existingDateGroup: "Ist das am selben Datum passiert wie",
    newDate: "Keines der oben genannten Daten",
    newDateHelp: "",
    pickExistingDateHelp: "",
    markAsReviewed: "Als geprüft markieren",
    endDiary: "Tagebuch beenden",
    reinstate: "Wiederherstellen",
    contactPatient: "Patient kontaktieren",
    endDiaryTitle: "Tagebuch beenden",
    endDiaryNotifyQuestion: "Möchten Sie den Patienten benachrichtigen?",
    justEndDiary: "Nur beenden",
    endDiaryAndNotify: "Beenden und Patient benachrichtigen",
    markReviewedTitle: "Als geprüft markieren",
    markReviewedNotifyQuestion: "Möchten Sie den Patienten benachrichtigen, dass sein Tagebuch geprüft wurde?",
    justMarkReviewed: "Nur als geprüft markieren",
    notifyPatient: "Patient benachrichtigen",
    from: "Von",
    to: "An",
    subject: "Betreff",
    emailBody: "E-Mail-Text",
    send: actionCopyDe.send,
    sending: actionCopyDe.sending,
    emailSentSuccess: "E-Mail erfolgreich gesendet",
    emailSentDescription: "Der Patient wurde benachrichtigt",
    emailSendFailed: "E-Mail konnte nicht gesendet werden",
    seeYourPatients: "Ihre Patienten ansehen",
    seeYourPatientsDescription: "Fortschritt verfolgen und Tagebücher verwalten",
    goToPatients: "Zu Patienten",
    goingToPatients: "Weiter zu Patienten...",
    reliableEmailWarning: "Für zuverlässige Zustellung empfehlen wir Gmail, Outlook oder iCloud.",
    entryRecordedTitle: "Eintrag erfolgreich erfasst",
    entryRecordedPending: (count) =>
        `Es ${count === 1 ? "steht noch 1 Eintrag" : `stehen noch ${count} Einträge`} für diesen Patienten aus. Bitte stellen Sie sicher, dass alle erforderlichen Assessments abgeschlossen sind.`,
    entryRecordedComplete:
        "Alle erforderlichen Einträge für diesen Patienten sind abgeschlossen. Der Datensatz ist jetzt aktuell.",
    continueToNextEntry: "Weiter zum nächsten Eintrag",
    returnToPatient: "Zurück zum Patienten",
    loadingTemplates: "Vorlagen werden geladen…",
    addToDiaryTitle: "Zum Tagebuch hinzufügen",
    addToDiaryDescription:
        "Fügen Sie eine Behandlung, Einwilligung oder einen Fragebogen hinzu, oder starten Sie mit einer Vorlage.",
    addManually: "Manuell hinzufügen",
    addManuallyDescription:
        "Geben Sie Behandlungs- und Fragebogendetails Schritt für Schritt ein, ohne eine Vorlage zu verwenden.",
    chooseTemplate: "Vorlage auswählen",
    chooseTemplateDescription:
        "Wählen Sie eine gespeicherte Vorlage, um Behandlungs- und Fragebogendetails für dieses Tagebuch vorzufüllen.",
    reviewTemplate: "Vorlage prüfen",
    reviewTemplateDescription: "Bestätigen Sie die Angaben, bevor Sie sie diesem Tagebuch hinzufügen.",
    confirmAndContinue: "Bestätigen und fortfahren",
    notifyPatientTitle: "Patient benachrichtigen?",
    intervention: "Intervention",
    openingTemplateProcedure: "Ihre Vorlagen-Behandlung wird geöffnet…",
    existingQuestionnaires: "Vorhandene Fragebögen",
    continueWithAllQuestionnaires: "Mit allen Fragebögen fortfahren",
    upcomingEntries: "Bevorstehende Einträge",
    noUpcomingEntries: "Keine bevorstehenden Einträge.",
    moreEntriesSummary: (count) => `… ${count} weitere Einträge …`,
    unlocks: (date) => `Verfügbar ab ${date}`,
    diaryEnded: "Tagebuch beendet",
    failedToEndDiary: "Tagebuch konnte nicht beendet werden",
    tableSettingsSaved: "Tabelleneinstellungen gespeichert",
    diaryAlreadyRead: "Tagebuch bereits gelesen",
    diaryReviewedSubject: "Tagebuch geprüft",
    newDiary: "Neues Tagebuch",
    searchTemplatesPlaceholder: "Nach Behandlung, Bereich oder Fragebogen suchen…",
    noTemplatesYet: "Sie haben noch keine Vorlagen. Erstellen Sie eine, um Patienten einzuladen.",
    noTemplatesMatch: "Keine Vorlagen entsprechen Ihrer Suche.",
    searchTemplatesShort: "Vorlagen suchen…",
    procedureFilterInjection: "Injektion",
    procedureFilterSurgery: "Operation",
    procedureFilterShockwave: "Stoßwelle",
    procedureFilterConsultation: "Beratung",
    procedureFilterProduct: "Produkt",
    checkingActiveQuestionnaires: "Aktive Fragebögen werden geprüft…",
    stopQuestionnairesDescription:
        "Stoppen Sie Fragebögen, bevor Sie einen neuen hinzufügen, oder fahren Sie mit allen aktiven fort.",
    noActiveQuestionnairesDescription: "Keine aktiven Fragebögen. Fahren Sie fort, um einen neuen hinzuzufügen.",
    stopping: "Wird gestoppt…",
    stopAllCurrentQuestionnaires: "Alle aktuellen Fragebögen stoppen",
    stopOnly: (name) => `Nur ${name} stoppen`,
    stopJoined: (list) => `${list} stoppen`,
    stopTrackerAria: (name) => `${name} stoppen`,
    checkingActiveBeforeTemplate: "Aktive Fragebögen werden vor der Vorlagenbestätigung geprüft…",
    templateExistingTrackersDescription:
        "Markieren Sie Fragebögen, die Sie stoppen möchten, bevor Sie aus dieser Vorlage hinzufügen, oder fahren Sie mit allen aktiven fort.",
    newPatientDiary: "Neues Patiententagebuch",
    newPatientDiaryDescription: "Vorlage wählen, Einrichtung prüfen, dann Patient einladen.",
    createTemplate: "Vorlage erstellen",
    favourites: "Favoriten",
    allTemplates: "Alle Vorlagen",
    needFiltersHint: "Filter oder Vorlagenverwaltung benötigt?",
    browseAllTemplates: "Alle Vorlagen ansehen",
    cc: "Cc",
    saving: "Wird gespeichert…",
    interventionTypeQuestion: "Welche Art von Intervention?",
    selectInterventionRequired: "Bitte wählen Sie eine Interventionsart",
    questionnairesLabel: "Fragebögen",
    continueLabel: "Weiter",
    notifyPatientUpdatedDescription:
        "Die Vorlage wurde dem Tagebuch hinzugefügt. Möchten Sie dem Patienten eine Nachricht über die Aktualisierung senden?",
    noJustFinish: "Nein, nur abschließen",
    yesNotifyPatient: "Ja, Patient benachrichtigen",
    diaryUpdatedFromTemplate: "Tagebuch aus Vorlage aktualisiert",
    couldNotApplyTemplate: "Vorlage konnte nicht angewendet werden",
    updateMessageTitle: "Patienten kontaktieren?",
    updateMessageDescription: "Nach dem Speichern eine Nachricht an den Patienten senden.",
    noJustSave: "Nein, nur speichern",
    yesSendMessage: "Ja, Nachricht senden",
    saveAndMessagePatient: "Speichern und Patient kontaktieren",
    saveOnly: "Speichern",
    updateQuestionnairesTitle: "Fragebögen",
    updateQuestionnairesDescription: "Fragebögen und Zeitpläne für die Nachverfolgung auswählen",
    selectQuestionnaire: "Fragebogen auswählen",
    selectQuestionnaireHelp: "Welche Fragen soll der Patient beantworten?",
    selectSchedule: "Zeitplan auswählen",
    selectScheduleHelp: "Wann soll der Patient den Fragebogen ausfüllen?",
    addAnotherQuestionnaire: "Weiteren Fragebogen hinzufügen",
    continueWithoutQuestionnaires: "Ohne Fragebögen fortfahren",
    referenceDateTitle: "Datum",
    referenceDateDescription:
        "Legen Sie das Datum fest, an dem die Behandlung oder der Nachverfolgungszeitraum beginnt.",
    contactStepDescription: "Wer ist die Kontaktperson?",
    questionnaireWithIndex: (index: number) => `Fragebogen ${index}`,
    setFlag: "Markierung setzen",
    editStatus: "Status bearbeiten",
    setFlagTitle: "Status bearbeiten",
    setFlagDescription: "Dies ersetzt den automatischen Status, bis Sie das Tagebuch wieder freigeben.",
    flagOnTrack: "Im Plan",
    flagImproved: "Verbessert",
    flagWorsening: "Wieder verschlechtert",
    flagNotImproving: "Keine Besserung",
    flagNoteLabel: "Notiz",
    flagNotePlaceholder: "Optionale interne Notiz",
    saveFlag: "Status speichern",
    resumeAutomatic: "Automatischen Status fortsetzen",
    resumeAutomaticHint: "Der Status wird erneut aus den Einträgen der Patientin oder des Patienten berechnet.",
    setManually: "Manuell gesetzt",
    setManuallyBy: (name) => `Gesetzt von ${name}`,
    teamRecordTitle: "Teamprotokoll",
    teamRecordPrivate: "Nur für Behandelnde und Admins sichtbar. Patientinnen und Patienten sehen das nicht.",
    notesTitle: "Notizen (nicht mit Patientinnen und Patienten geteilt)",
    notesDescription: "Interne Notizen (nicht mit Patientinnen und Patienten geteilt)",
    noteByline: (author, when) => `Von ${author} ${when}`,
    noteJustNow: "jetzt",
    addNote: "Notiz hinzufügen",
    notePlaceholder: "Interne Notiz schreiben",
    saveNote: "Notiz speichern",
    editNote: "Bearbeiten",
    addNoteName: "Namen hinzufügen",
    noteNameLabel: "Name",
    saveNoteEdit: "Speichern",
    deleteNote: "Löschen",
    deleteNoteTitle: "Notiz löschen",
    deleteNoteConfirm: "Diese Notiz wird entfernt. Das kann nicht rückgängig gemacht werden.",
    noteDeleted: "Notiz gelöscht",
    couldNotDeleteNote: "Notiz konnte nicht gelöscht werden",
    cancelNoteEdit: "Abbrechen",
    noteEdited: "Bearbeitet",
    statusChangedTo: "Status geändert zu",
    statusSetVerb: "setzte",
    statusResumed: (name) => `${name} hat den automatischen Status wiederhergestellt`,
    noTeamRecord: "Noch keine Statusänderungen.",
    couldNotSaveFlag: "Markierung konnte nicht gespeichert werden",
    couldNotSaveNote: "Notiz konnte nicht gespeichert werden",
    flagSaved: "Markierung gespeichert",
    noteSaved: "Notiz gespeichert",
};
